import axios, { AxiosError, AxiosPromise, AxiosRequestConfig } from "axios";
import { clearAllCookie, getToken } from "./auth";
import { createBrowserHistory } from 'history';
import { APIPath } from "baserURL";


export const authPages = [
  "/auth/sign-in",
  "/auth/signup",
];

let cancelTokenSource = axios.CancelToken.source();

export default function authRequest(
  options: AxiosRequestConfig & { authRequired?: boolean },
  token?: string,
  clientId?: string,
  clientSecret?: string
): AxiosPromise<any> {
  const { authRequired = true, ...axiosConfig } = options;
  const history = createBrowserHistory()
  token = token ?? getToken();
  if (authRequired && !token) {
    clearAllCookie();
    history.push("/auth/sign-in");
    window.location.reload()
    // return Promise.reject(new AxiosError("Invalid Token", "401"));
    // return Promise.reject();
  }
  cancelTokenSource = axios.CancelToken.source();

  let headers :any = '';
  if(!authRequired) {
    headers = {
      "Content-Type": "application/json",
      Accept: "*/*",
      ...(clientId && { "client-id": clientId }), // Add client-id if provided
      ...(clientSecret && { "client-secret": clientSecret }), // Add client-secret if provided
    };
  } else {
    headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "*/*",
      ...(clientId && { "client-id": clientId }), // Add client-id if provided
      ...(clientSecret && { "client-secret": clientSecret }), // Add client-secret if provided
    };
  }
  

  const request = axios.create({
    // baseURL: process.env.REACT_APP_API_BASE_URL,
    baseURL: APIPath,
    headers,
    cancelToken: cancelTokenSource.token,
  });
  request.interceptors.response.use(
    function (res) {
      return res;
    },
    function (error) {
      if (
        error?.response?.status === 401 &&
        !!!authPages?.find((path) => window.location.href.includes(path))
      ) {
        // dispatch(initMain())
        clearAllCookie();

        history.push("/auth/sign-in");
        window.location.reload()

      }
      if (error?.response?.status === 422) {
        return Promise.reject(
          new AxiosError("Please provide valid values", "422")
        );
      }
      // else {
      //   try {
      //     const { email, message } = JSON.parse(error?.response?.data?.detail);
      //     if (email) {
      //       // redirect to verify-email page
      //       logout({ email });
      //       return Promise.reject({
      //         ...error,
      //         response: {
      //           ...error?.response,
      //           data: { ...error?.response?.data, detail: message },
      //         },
      //       });
      //     }
      //   } catch (err) {}
      // }
      return Promise.reject(error);
    }
  );
  return request(options);
}

export function cancelRequest() {
  cancelTokenSource.cancel();
}

export function isCanceled(err: any) {
  return axios.isCancel(err);
}
